var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    {
      attrs: { "two-line": "" },
      on: {
        click: function ($event) {
          return _vm.showDetail(_vm.reintegro)
        },
      },
    },
    [
      _c(
        "v-list-item-content",
        [
          _c("v-list-item-title", [
            _c("strong", [
              _vm._v("Modello: " + _vm._s(_vm.reintegro.idModello)),
            ]),
          ]),
          _c("v-list-item-subtitle", [
            _vm._v("Stagione: "),
            _c("strong", [_vm._v(_vm._s(_vm.reintegro.idStagione))]),
            _vm._v(" - Colore: "),
            _c("strong", [_vm._v(_vm._s(_vm.reintegro.idColore))]),
            _vm._v(" "),
            _c("em", [
              _vm._v("(id " + _vm._s(_vm.reintegro.idDistintaDPCStatica) + ")"),
            ]),
          ]),
          _c("v-list-item-subtitle", [
            _vm._v("Data inserimento: "),
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm._f("formatDateTime")(_vm.reintegro.dataOraInserimento)
                )
              ),
            ]),
            _vm._v(" - Righe reintegro: "),
            _c("strong", [_vm._v(_vm._s(_vm.reintegro.numRighe))]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }